import { Routes, Route} from 'react-router-dom'

import SignIn from '../pages/SignIn'
import SignUp from '../pages/SignUp'
import Dashboard from '../pages/Dashboard'
import Profile from '../pages/Profile'
import Customers from '../pages/Customers'
import Perfil from '../pages/Perfil'
import Game from '../pages/Game'
import EditPost from '../pages/Edicao';
import Private from './Private'
import ForgotPassword from '../pages/ForgotPassword'

function RoutesApp(){
    return(
        <Routes>
            <Route path='/' element={ <SignIn/> }/>
            <Route path='/register' element={ <SignUp/> }/>
            <Route path="/forgot-password" element={ <ForgotPassword/> } />

            <Route path='/feed' element={ <Private><Dashboard/></Private> }/>
            <Route path='/perfil' element={ <Private><Profile/></Private> }/>
            <Route path='/criarpost' element={ <Private><Customers/></Private> }/>
            <Route path='/meusposts' element={ <Private><Perfil/></Private> }/>
            <Route path='/conquistas' element={ <Private><Game/></Private> }/>
            <Route path='/editar' element={ <Private><EditPost/></Private> }/>
        </Routes>
    )
}

export default RoutesApp;